import { ASSET_PATHS } from '../../utils/assetPath';

import './JPGFileIcon.css';

interface JPGFileIconProps {
  /**
   * Additional CSS class name
   */
  className?: string;
  /**
   * Icon size in pixels
   */
  size?: number;
  /**
   * Accessible label for the icon
   */
  ariaLabel?: string;
}

function JPGFileIcon({ className = '', size = 32, ariaLabel = 'JPG file' }: JPGFileIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`jpg-file-icon ${className}`}
      height={size}
      src={ASSET_PATHS.JPG_FILE_ICON}
      width={size}
    />
  );
}

export default JPGFileIcon;
